<template>
  <tbody v-if="isLoading">
    <tr>
      <td
        :colspan="cols"
        class="text-center"
      >
        <div class="loading">
          <span class="loader" />
        </div>
      </td>
    </tr>
  </tbody>
  <tbody v-else-if="isEmpty">
    <tr>
      <td>
        <p>
          {{ $t('NotFoundOrder') }}
        </p>
      </td>
    </tr>
  </tbody>

  <tbody v-else>
    <slot />
  </tbody>
</template>

<script>
export default {
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    disabledRow: {
      type: Boolean,
      default: false,
    },
    cols: {
      type: Number,
      default: 8,
    },
    responseData: {
      type: [Array, Object, String, null],
      default: null,
    },
  },
  computed: {
    isEmpty() {
      if (this.responseData === null || this.responseData === undefined) {
        return false;
      }

      return (
        this.responseData === ''
        || (Array.isArray(this.responseData) && this.responseData.length === 0)
        || (typeof this.responseData === 'object' && Object.keys(this.responseData).length === 0)
      );
    },
  },
};
</script>
